export const sets = [
  {
    code: 'znr',
    name: 'Zendikar Rising',
    path: '/articles/cube-prospective-zendikar-rising/',
  },
  {
    code: 'cmr',
    name: 'Commander Legends',
    path: '/articles/cube-prospective-commander-legends/',
  },
  {
    code: 'khm',
    name: 'Kaldheim',
    path: '/articles/cube-prospective-kaldheim/',
  },
  {
    code: 'stx',
    name: 'Strixhaven',
    path: '/articles/cube-prospective-strixhaven-school-of-mages/',
  },
  {
    code: 'c21',
    name: 'Commander 2021',
    path: '/articles/cube-prospective-commander-2021/',
  },
  {
    code: 'mh2',
    name: 'Modern Horizons 2',
    path: '/articles/cube-prospective-modern-horizons-2/',
  },
  {
    code: 'afr',
    name: 'Adventures in the Forgotten Realms',
    path: '/articles/cube-prospective-adventures-in-the-forgotten-realms/',
  },
  {
    code: 'afc',
    name: 'Forgotten Realms Commander',
    path: '/articles/cube-prospective-forgotten-realms-commander/',
  },
]
